var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    staticClass: "ws-dialog",
    attrs: {
      "width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "mt-n1 ml-n1",
          attrs: {
            "icon": "",
            "small": ""
          }
        }, on), [_c('v-icon', {
          attrs: {
            "size": "18"
          }
        }, [_vm._v(" mdi-help-circle ")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('about-text', {
    on: {
      "toggle": function ($event) {
        _vm.dialog = false;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }